import { Hosts } from '.';

const hosts: Hosts = {
  CTL_AUTHENTICATOR_SERVER: 'https://aipf-auth-ctl.csg.lunit.io',
  CTL_DATA_SERVER: 'https://aipf-data-ctl.csg.lunit.io',
  CTL_IMAGE_SERVER: 'https://aipf-image-ctl.csg.lunit.io',
  AIPF_PORTAL_DOMAIN: 'https://aipf.tig.lunit.io',
};

export default hosts;
